/**
 * @generated SignedSource<<e92f17c2684c2ed8137e97294ac2d06b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleTypesAssignTeam$data = {
  readonly employeeScheduleTypes: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType">;
  }>;
  readonly " $fragmentType": "EmployeeScheduleEditScheduleTypesAssignTeam";
};
export type EmployeeScheduleEditScheduleTypesAssignTeam$key = {
  readonly " $data"?: EmployeeScheduleEditScheduleTypesAssignTeam$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleTypesAssignTeam">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleEditScheduleTypesAssignTeam",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "employeeScheduleTypes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "d4b56bb90152ab1f1054b27d07e86248";

export default node;
